module.exports = __webpack_public_path__ + "static/media/pc_bg.dae34463.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pc_bg.png
// module id = 2244
// module chunks = 0